/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sl_Lots_Col_AvailableInputs */

const vi_sl_lots_col_available = /** @type {(inputs: Sl_Lots_Col_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KL khả dụng`)
};

/**

* @param {Sl_Lots_Col_AvailableInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sl_lots_col_available = /** @type {((inputs?: Sl_Lots_Col_AvailableInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sl_Lots_Col_AvailableInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sl_lots_col_available(inputs)
});